<div id="welcome-dialog-container" class="modal-dialog">
	<div class="modal-content">
		<div class="goreact-modal-body" cdkTrapFocus>
			<welcome-step *ngIf="(step$ | async) === welcomeStepsState.WELCOME" (onProceed)="continue()" [data]="data" [showSelfPayStep]="showSelfPayStep" [showFreeTrialStep]="hasFreeTrialLicense" [loading$]="showLoadingIndicator$"></welcome-step>
			<choose-plan *ngIf="(step$ | async) === welcomeStepsState.CHOOSE_PLAN" (onBack)="back()" (onSelfPay)="close({selfPay: true})" (onStudentPay)="close({selfPay: false})"></choose-plan>
		</div>
	</div>
</div>
